import { useState } from 'react';
import {
  Dialog,
  Stack,
  Grid,
  Button,
  Typography,
  Box,
  IconButton,
  CircularProgress,
} from '@mui/material';

import Checkbox from '../checkbox/Checkbox';
import Icon from '../Icon';

const DeleteAuthKeyDialog = ({
  isDialogShow,
  onDialogAction,
  onCreateAction,
  isAuthKeyRegenerating,
}) => {
  const [isChecked, setCheckboxState] = useState(false);

  const checkboxStateHandler = () => {
    setCheckboxState((prevState) => !prevState);
  };

  return (
    <Dialog open={isDialogShow} onClose={onDialogAction}>
      <Stack sx={{ gap: '24px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2" sx={{ textAlign: 'left' }}>
            Key Regeneration
          </Typography>
          <IconButton sx={{ p: 0 }} onClick={onDialogAction}>
            <Icon id="close-dialog" width={24} height={24} />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start',
            padding: '12px',
            bgcolor: '#fff9eb',
            border: '1px solid  #ffd480',
            borderRadius: '10px',
            textAlign: 'left',
          }}
        >
          <Icon
            id="warning"
            width="24"
            height="24"
            style={{ flex: '1 0 22px' }}
          />
          <Typography
            variant="body2"
            component="span"
            sx={{ letterSpacing: 0 }}
          >
            After regeneration, the old key will stop working. <br /> All
            previously deployed agents and integrations using this key will lose
            access. <br />
            Are you sure you want to regenerate the key?
          </Typography>
        </Box>
        <Checkbox
          label={
            <Typography
              variant="body2"
              component="span"
              sx={{
                fontSize: '14px',
                lineHeight: '20px',
                color: '#414E62',
                letterSpacing: 0,
              }}
            >
              I understand the old key will be revoked and can’t be recovered
            </Typography>
          }
          checked={isChecked}
          onChange={checkboxStateHandler}
          sx={{
            alignItems: 'flex-start',
            '.MuiCheckbox-root': {
              pt: 0,
              pl: 0,
            },
            '.MuiTypography-root': {
              textAlign: 'left',
            },
          }}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Button
              variant="outlined"
              size="small"
              onClick={onDialogAction}
              sx={{ width: '100%' }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="contained"
              size="small"
              onClick={onCreateAction}
              disabled={!isChecked || isAuthKeyRegenerating}
              sx={{
                width: '100%',
                // TODO: This is a bad way to apply disabled state,
                // find a way to make it generic alongside with error buttons disabled state
                '&:disabled': {
                  backgroundColor: 'primary.light',
                  color: '#fff',
                },
              }}
            >
              Regenerate
              {isAuthKeyRegenerating ? (
                <CircularProgress size={15} sx={{ ml: 1, color: '#fff' }} />
              ) : null}
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Dialog>
  );
};

export default DeleteAuthKeyDialog;
